import Vue from "vue"
import Vuex from "vuex"
import moduleAll from './stores'

Vue.use(Vuex)

export default new Vuex.Store({
  modules : moduleAll
})
